import { CardClassification, CardNetwork } from "@/modules/card/common/enum";
import { CloudflareAsset } from "@/shared/common/enums";

export const CardImages = {
  [CardClassification.Classic]: CloudflareAsset.ClassicCard,
  [CardClassification.Platinum]: CloudflareAsset.PlatinumCard,
};

export const CardNetworkIcon = {
  [CardNetwork.Visa]: CloudflareAsset.Visa,
  [CardNetwork.MasterCard]: CloudflareAsset.MasterCard,
  [CardNetwork.ArCa]: CloudflareAsset.ArCa,
};

export const CardNetworkIconSmall = {
  [CardNetwork.Visa]: CloudflareAsset.VisaSmall,
  [CardNetwork.MasterCard]: CloudflareAsset.MasterCardSmall,
  [CardNetwork.ArCa]: CloudflareAsset.ArCaSmall,
};
